import { Button, Col, Divider, Form, Row, Space, Spin, Tooltip } from "antd";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { ReactComponent as ExpandIconSVG } from "assets/images/svg/expand.svg";
import "./Receive.scss";
import HealthInsuranceInfo from "./components/HealthInsuranceInfo/HealthInsuranceInfo";
import PolicyInfo from "./components/PolicyInfo/PolicyInfo";
import PatientWaiter from "./components/PatientWaiter/PatientWaiter";
import {
  receiveSetFieldsValue,
  CancelBtn,
  CompleteBtn,
  SavePrintBtn,
  SaveBtn,
  NewPatientBtn,
  NewMedicalBillBtn,
  InsuranceDataType,
  PayBtn,
  CompleteKCBBtn,
} from "./config";
import { medicalExaminationService, receiveService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";
import { tabKeys } from "types/enums";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
  setSiderKey,
} from "redux/reducer/common";
import { setAction } from "redux/reducer/receive";
import { useNavigate } from "react-router-dom";
import MainInfo from "./components/MainInfo/MainInfo";
import ExpandInfo from "./components/ExpandInfo/ExpandInfo";
import RelativeInfo from "./components/RelativeInfo/RelativeInfo";
import ReceiveInfo from "./components/ReceiveInfo/ReceiveInfo";
import RegisterInfo from "./components/RegisterInfo/RegisterInfo";
import {
  birthday2Age,
  formatDateToStringTimezone_7,
  convertDateStringToDateTimezone_7,
  removeSpaces,
  disableBtn,
} from "helper/common";
import { setPatientRecord } from "redux/reducer/patientRecord";
import Notification from "components/common/notification/notification";
import { setReload } from "redux/reducer/receiveReload";
import CancelModal from "./components/CancelModal/CancelModal";
import ExanRegBill from "./components/ExamRegBill/ExamRegBill";
import { setId } from "redux/reducer/reduxCommon";
import dayjs from "dayjs";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
import AlertModal from "components/common/AlertModal/AlertModal";
import { ModalCustom } from "components/common";
import SignedSecure from "./components/SignSecure/SignedSecure/SignedSecure";
import { CheckCircleFilled } from "@ant-design/icons";

const Receive = () => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.common.activeTab);
  const action = useAppSelector((state) => state.receive);

  const [appliedPolicy, setAppliedPolicy] = useState<any[]>([]);
  const [insuranceData, setInsuranceData] = useState<InsuranceDataType | null>(
    null
  );
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [expandMoreInfo, setExpandMoreInfo] = useState<boolean>(false);
  const [expandRelativeInfo, setExpandRelativeInfo] = useState<boolean>(false);
  const signSecureRef = useRef<any>();
  const examRef = useRef<any>();
  const [form] = Form.useForm();
  const cancelRef = useRef<any>();
  const modalRef = useRef<any>(null);
  const [fileImg, setFileImg] = useState<File | string | object>({});

  const handleOnView = async () => {
    try {
      const res = await receiveService.getImgByPatient(
        action.dataPassing?.maBenhNhan
      );
      // console.log("🚀 ~ handleOnView ~ res:", res);
      // const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/get-by-id-benh-nhan?id=151290`;
      // const res = await axiosClient.get(url);
      console.log("🚀 ~ handleOnView ~ url:", res);
      // const data = res.data;
      // console.log("🚀 ~ handleOnView ~ data:", data);
      setFileImg(res);
    } catch (error) {
      console.log("🚀 ~ handleOnView ~ error:", error);
    }
  };
  const saveData = async (values, isConvert_7, type = 0) => {
    let response;
    const data = {
      ...values,
      hoTenTrenThe: values.hoTen?.toUpperCase(),
      hoTen: values?.hoTen?.toUpperCase(),
      // ngaySinh: formatDateToStringTimezone_7(values?.ngaySinh, isConvert_7),
      // ngaySinhTrenThe: formatDateToStringTimezone_7(
      //   values?.ngaySinhTrenThe,
      //   isConvert_7
      // ),
      // ngaySinhThanNhan: formatDateToStringTimezone_7(
      //   values?.ngaySinhThanNhan,
      //   isConvert_7
      // ),
      ngaySinh: values.ngaySinh
        ? dayjs(values.ngaySinh).format("YYYY-MM-DDT00:00:00.000+07:00")
        : null,
      ngaySinhTrenThe: values.ngaySinhTrenThe
        ? dayjs(values.ngaySinhTrenThe).format("YYYY-MM-DDT00:00:00.000+07:00")
        : null,
      ngaySinhThanNhan: values.ngaySinhThanNhan
        ? dayjs(values.ngaySinhThanNhan).format("YYYY-MM-DDT00:00:00.000+07:00")
        : null,
      the5Nam: values.the5Nam
        ? dayjs(values.the5Nam).format("YYYY-MM-DDT00:00:00.000+07:00")
        : null,

      ngayNhapVien: formatDateToStringTimezone_7(
        values?.ngayNhapVien,
        isConvert_7
      ),
      ngayCapNhatThe: formatDateToStringTimezone_7(
        values?.ngayCapNhatThe,
        isConvert_7
      ),
      thoiGianNhapVienNoiTru: formatDateToStringTimezone_7(
        values?.thoiGianNhapVienNoiTru,
        isConvert_7
      ),
      thoiGianTraThe: formatDateToStringTimezone_7(
        values?.thoiGianTraThe,
        isConvert_7
      ),
      // the5Nam: formatDateToStringTimezone_7(values?.the5Nam, isConvert_7),
      ngayTao: formatDateToStringTimezone_7(values?.ngayTao, isConvert_7),
      ngayCap: formatDateToStringTimezone_7(values?.ngayCap, isConvert_7),
      ngayBatDau: formatDateToStringTimezone_7(values?.ngayBatDau, isConvert_7),
      ngayKetThuc: formatDateToStringTimezone_7(
        values?.ngayKetThuc,
        isConvert_7
      ),
      // ngayNhapVien: values.ngayNhapVien`
      //   ? values.ngayNhapVien.toISOString()
      //   : null,
      // ngayNhapVien: values.ngayNhapVien
      //   ? dayjs(values.ngayNhapVien).format("YYYY-MM-DDTHH:mm:ss.sss") +
      //     "+07:00"
      //   : null,
      tuoi: null,
      thoiGianMienCungChiTra: values.thoiGianMienCungChiTra
        ? dayjs(values.thoiGianMienCungChiTra).format(
            "YYYY-MM-DDT00:00:00.000+07:00"
          )
        : null,
    };

    if (type == 0) {
      response = await medicalExaminationService.postMedicalBill(data);
    } else {
      if (values?.hoTen == action.dataPassing?.hoTen) {
        response = await medicalExaminationService.putMedicalBill(data);
      } else {
        response = await medicalExaminationService.putMedicalBill(data);
      }
    }

    return {
      ...response,
      data: {
        ...response?.data,
        // ngaySinh: convertIosStringToDateDayjs(response?.data?.ngaySinh),
      },
    };
  };
  //hủy khám
  const cancelFunc = () => {
    if (action.actionType == RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
      if (action.dataPassing.trangThai != 6) {
        cancelRef.current?.openModal();
      } else {
        Notification("info", "Phiếu khám đã ở trạng thái hủy khám!");
      }
    } else {
      resetFormField();
      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.HUYKHAM,
          dataPassing: null,
        })
      );
    }
  };

  //đang không biết để làm gì?????
  const handleCancelOk = async () => {
    try {
      let response = await medicalExaminationService.updateStatus({
        id: action.dataPassing.id,
        trangThai: 6,
      });
      if (response.status == 200) {
        // setCancelOpen(false);
        Notification("success", "Đã hủy khám");
        resetFormField();
        dispatch(
          setAction({
            actionType: RECEIVE_ACTION_TYPE.HUYKHAM,
            dataPassing: null,
          })
        );
        dispatch(setActiveKey(tabKeys.RECEIVE.TAB_1));
        dispatch(setReload(true));
      }
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi hủy khám");
    }
  };

  // const notCancel = () => {
  //   setCancelOpen(false);
  // };

  //haonf thành khai báo
  const hoanThanhKhaiBao = async (idPhieuKham) => {
    let response = await medicalExaminationService.hoanThanhKhaiBao(
      idPhieuKham
    );
    return response.data;
  };

  //Hoàn thành kcb
  const completeKCBFunc = async (dt) => {
    setLoading(true);
    setLoadingBtn(true);
    return new Promise((resolve, reject) => {
      form.validateFields().then(async (values) => {
        try {
          if (
            action.dataPassing?.id != null &&
            action.dataPassing?.trangThai != null
          ) {
            let response = await saveData(
              {
                ...action.dataPassing,
                ...values,
                ...dt.insuranceData,
                chinhSachApDungs: dt.appliedPolicy,
                trangThai: 3,
              },
              false,
              1
            );
            if (response.status && response.status == 200) {
              dispatch(setReload(true));
              dispatch(
                setPatientRecord({
                  selected: true,
                  record: response.data,
                })
              );
              dispatch(
                setAction({
                  actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                  dataPassing: response.data,
                })
              );
              form.setFieldsValue({
                trangThai: response.data.trangThai,
              });
              resolve(true);
              Notification("success", "Hoàn thành phiếu khám thành công!");
              setLoadingBtn(false);
              setLoading(false);
            }
          } else {
            setLoadingBtn(false);
            setLoading(false);
            Notification("error", "Chưa có thông tin bệnh nhân!");
            resolve(false);
          }
        } catch (err) {
          setLoadingBtn(false);
          setLoading(false);
          resolve(false);
        }
      });
    });
  };
  //Hoàn thành khai báo
  const completeFunc = async () => {
    setLoadingBtn(true);
    form
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          dienThoai: removeSpaces(values.dienThoai),
          nguonBn: values?.nguonBn ?? null,
          // tenDoan:
          //   values?.nguonBn === "Đoàn khám tại viện" ||
          //   values?.nguonBn === "Đoàn khám tại địa phương"
          //     ? values?.tenDoan
          //     : null,
        };
        if (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
          await saveData(
            {
              ...values,
              id: null,
              maBenhNhan: values.maBenhNhan,
              ...insuranceData,
              chinhSachApDungs: appliedPolicy,
              trangThaiThanhToan: 0,
              lanThanhToan: 0,
              trangThai: 0,
              hoanThanhKhaiBao: false,
              nhanVienTiepNhan: localStorage.getItem("fullName"),
            },
            false
          )
            .then((data) => {
              if (data.status == 200) {
                form.setFieldValue("id", data?.id);
                form.setFieldValue("maBenhNhan", data?.maBenhNhan);
                hoanThanhKhaiBao(data.data.id)
                  .then((res) => {
                    Notification("success", "Phiếu đã khai báo thành công");
                    dispatch(setReload(true));
                    dispatch(setActiveKey(tabKeys.RECEIVE.TAB_1));
                    // dispatch(
                    //   setAction({
                    //     actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                    //     dataPassing: data.data,
                    //   })
                    // );
                    dispatch(setIdPhieuKham(null));
                    setLoadingBtn(false);
                    setLoading(false);
                  })
                  .catch((err) => {
                    setLoadingBtn(false);
                    setLoading(false);
                    Notification("error", err.response.data ?? "Lỗi xảy ra!");
                  });
              }
              setLoadingBtn(false);
              setLoading(false);
            })
            .catch((err) => {
              setLoadingBtn(false);
              setLoading(false);

              Notification("error", err.response.data ?? "Lỗi xảy ra!");
            });
        } else if (action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
          await saveData(
            {
              ...action.dataPassing,
              ...values,
              maBenhNhan: null,
              ...insuranceData,
              chinhSachApDungs: appliedPolicy,
              thoiGianMienCungChiTra: values.thoiGianMienCungChiTra ?? null,
            },
            false,
            1
          )
            .then((data) => {
              const ngayNhapVienData = data.data.ngayNhapVien;
              const res = disableBtn(ngayNhapVienData);
              console.log("🚀 ~ .then ~ res:", res);
              if (res) {
                modalRef.current.openModal();
                setLoadingBtn(false);
                setLoading(false);
                return;
              }
              if (data.status == 200) {
                Notification("success", "Lưu thành công!");
                dispatch(setReload(true));
                hoanThanhKhaiBao(values.id)
                  .then((res) => {
                    Notification("success", "Phiếu đã khai báo thành công");
                    dispatch(setActiveKey(tabKeys.RECEIVE.TAB_1));
                    setLoadingBtn(false);
                    setLoading(false);
                  })
                  .catch((err) =>
                    Notification("error", err.response.data ?? "Lỗi xảy ra!")
                  );
                setLoadingBtn(false);
                setLoading(false);
              }
            })
            .catch((err) => {
              setLoadingBtn(false);
              setLoading(false);
              Notification("error", err.response.data ?? "Lỗi xảy ra!");
            });
        } else if (action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI) {
          try {
            const response = await saveData(
              {
                ...values,
                maBenhNhan: null,
                ...insuranceData,
                chinhSachApDungs: appliedPolicy,
                trangThai: 0,
                trangThaiThanhToan: 0,
                lanThanhToan: 0,
                hoanThanhKhaiBao: false,
                nhanVienTiepNhan: localStorage.getItem("fullName"),
              },
              false,
              0
            );
            Notification("success", "Thêm thành công!");
            dispatch(setReload(true));
            dispatch(
              setPatientRecord({
                selected: true,
                record: response.data,
              })
            );
            dispatch(
              setAction({
                actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                dataPassing: response.data,
              })
            );
            setLoadingBtn(false);
            setLoading(false);
            form.setFieldValue("id", response?.data?.id);
            hoanThanhKhaiBao(response?.data?.id)
              .then((res) => {
                Notification("success", "Phiếu đã khai báo thành công");
                dispatch(setReload(true));
                dispatch(setActiveKey(tabKeys.RECEIVE.TAB_1));
                setLoadingBtn(false);
                setLoading(false);
              })
              .catch((err) => {
                setLoadingBtn(false);
                setLoading(false);
                Notification("error", err.response.data ?? "Lỗi xảy ra!");
              });
            dispatch(setIdPhieuKham(null));
          } catch (error) {
            Notification("error", error.response.data ?? "Lỗi xảy ra!");
          }

          // resolve({ status: true, data: response.data });
          // if (response.data.hoanThanhKhaiBao) {
          // await saveData({
          //   ...values,
          //   id: values.id ? values.id : action.dataPassing.id,
          //   maBenhNhan: null,
          //   ...insuranceData,
          //   chinhSachApDungs: appliedPolicy,
          //   trangThaiThanhToan: 0,
          //   lanThanhToan: 0,
          //   trangThai: 0,
          //   hoanThanhKhaiBao: false,
          //   nhanVienTiepNhan: localStorage.getItem("fullName"),
          // })
          // .then((data) => {

          setLoadingBtn(false);
          setLoading(false);

          // })
          // .catch((err) =>
          //   Notification("error", err.response.data ?? "Lỗi xảy ra!")
          // );
        }
        // setLoadingBtn(false);
        setLoading(false);
        // }
      })
      .catch(() => {
        setLoadingBtn(false);
      });
    // setLoadingBtn(false);
    setLoading(false);
  };

  //Thanh toán
  const payFunc = async () => {
    // setLoading(true);
    setLoadingBtn(true);
    await form
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          dienThoai: removeSpaces(values.dienThoai),
          nguonBn: values?.nguonBn ?? null,
          // tenDoan:
          //   values?.nguonBn === "Đoàn khám tại viện" ||
          //   values?.nguonBn === "Đoàn khám tại địa phương"
          //     ? values?.tenDoan
          //     : null,
        };
        if (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
          await saveData(
            {
              ...values,
              id: null,
              maBenhNhan: values.maBenhNhan,
              ...insuranceData,
              chinhSachApDungs: appliedPolicy,
              trangThaiThanhToan: 0,
              lanThanhToan: 0,
              hoanThanhKhaiBao: false,
              nhanVienTiepNhan: localStorage.getItem("fullName"),
            },
            false
          )
            .then((data) => {
              if (data.status == 200) {
                if (data.data.hoanThanhKhaiBao) {
                  dispatch(setReload(true));
                  navigate("/thanh-toan/thanh-toan");
                  dispatch(setSiderKey("thanhToan"));
                  dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                  dispatch(setId(data.data.id));
                  setLoading(false);
                  setLoadingBtn(false);
                  setLoading(false);
                } else {
                  hoanThanhKhaiBao(data.data.id)
                    .then((res) => {
                      Notification("success", "Phiếu đã khai báo thành công");
                      dispatch(setReload(true));
                      navigate("/thanh-toan/thanh-toan");
                      dispatch(setSiderKey("thanhToan"));
                      dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                      dispatch(setId(data.data.id));
                      setLoading(false);
                      setLoadingBtn(false);
                      setLoading(false);
                    })
                    .catch((err) => {
                      setLoadingBtn(false);
                      setLoading(false);
                      Notification("error", err.response.data ?? "Lỗi xảy ra!");
                    });
                }
              }
              setLoadingBtn(false);
              setLoading(false);
            })
            .catch((err) => {
              Notification("error", err.response.data ?? "Lỗi xảy ra!");
              setLoading(false);
              setLoadingBtn(false);
              setLoading(false);
            });
        } else if (action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
          await saveData(
            {
              ...action.dataPassing,
              ...values,
              // idBenhNhan: Number(values.maBenhNhan),
              ...insuranceData,
              chinhSachApDungs: appliedPolicy,
              thoiGianMienCungChiTra: values.thoiGianMienCungChiTra ?? null,
            },
            false,
            1
          )
            .then((data) => {
              if (data.status == 200) {
                Notification("success", "Lưu thành công!");
                dispatch(setReload(true));
                if (data.data.hoanThanhKhaiBao) {
                  navigate("/thanh-toan/thanh-toan");
                  dispatch(setSiderKey("thanhToan"));
                  dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                  dispatch(setId(values.id));
                  setLoading(false);
                  setLoadingBtn(false);
                  setLoading(false);
                } else {
                  hoanThanhKhaiBao(values.id)
                    .then((res) => {
                      Notification("success", "Phiếu đã khai báo thành công");
                      navigate("/thanh-toan/thanh-toan");
                      dispatch(setSiderKey("thanhToan"));
                      dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                      dispatch(setId(values.id));
                      setLoading(false);
                      setLoadingBtn(false);
                      setLoading(false);
                    })
                    .catch((err) => {
                      Notification("error", err.response.data ?? "Lỗi xảy ra!");
                      setLoading(false);
                      setLoadingBtn(false);
                      setLoading(false);
                    });
                }
              }
            })
            .catch((err) => {
              Notification("error", err.response.data ?? "Lỗi xảy ra!");
              setLoading(false);
              setLoadingBtn(false);
              setLoading(false);
            });
        } else if (action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI) {
          await saveData(
            {
              ...values,
              // id: null,
              // idBenhNhan: Number(values.idBenhNhan),
              ...insuranceData,
              chinhSachApDungs: appliedPolicy,
              trangThaiThanhToan: 0,
              lanThanhToan: 0,
              hoanThanhKhaiBao: false,
              nhanVienTiepNhan: localStorage.getItem("fullName"),
            },
            true
          )
            .then(async (data) => {
              if (data.status == 200) {
                if (data.data.hoanThanhKhaiBao) {
                  dispatch(setReload(true));
                  navigate("/thanh-toan/thanh-toan");
                  dispatch(setSiderKey("thanhToan"));
                  dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                  dispatch(setId(data.data.id));
                  setLoadingBtn(false);
                  setLoading(false);
                  setLoading(false);
                } else {
                  await hoanThanhKhaiBao(data.data.id)
                    .then((res) => {
                      Notification("success", "Phiếu đã khai báo thành công");
                      dispatch(setReload(true));
                      navigate("/thanh-toan/thanh-toan");
                      dispatch(setSiderKey("thanhToan"));
                      dispatch(setActiveKey(tabKeys.PAY.PAY_TAB));
                      setLoadingBtn(false);
                      setLoading(false);
                      dispatch(setId(data.data.id));
                    })
                    .catch((err) => {
                      Notification("error", err.response.data ?? "Lỗi xảy ra!");
                      setLoadingBtn(false);
                      setLoading(false);
                      setLoading(false);
                    });
                }
              }
            })
            .catch((err) => {
              Notification("error", err.response.data ?? "Lỗi xảy ra!");
              setLoadingBtn(false);
              setLoading(false);
              setLoading(false);
            });
        }
        // dispatch(setLoadingBtn(false));
      })
      .catch(() => {
        setLoadingBtn(false);
      });
    // dispatch(setLoadingBtn(false));
  };

  //Tạo BN mới
  const newPatientFunc = async () => {
    dispatch(
      setPatientRecord({
        selected: false,
        record: null,
      })
    );
    resetFormField();
    dispatch(
      setAction({
        actionType: RECEIVE_ACTION_TYPE.BENHNHANMOI,
        dataPassing: {
          isClear: true,
          danToc: 0,
          ngheNghiep: "Nghề khác",
        },
      })
    );
  };
  const newMedicalBillFunc = async () => {
    dispatch(
      setPatientRecord({
        selected: false,
        record: null,
      })
    );
    dispatch(
      setAction({
        actionType: RECEIVE_ACTION_TYPE.PHIEUKHAMMOI,
        dataPassing: {
          id: null,
          anh: form.getFieldValue("anh"),
          ...action.dataPassing,
          isThanhToanCD: false,
        },
      })
    );
  };
  const savePrintFunc = async (dt) => {
    await saveFunc(dt)
      .then((res: any) => {
        setLoading(true);
        if (res?.status == true && res?.data != null) {
          examRef.current?.setIdPK(new Number(res?.data?.id));
          examRef.current?.openModal();
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const saveFunc = async (dt) => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then(async (values) => {
          setLoading(true);
          setLoadingBtn(true);

          // Object.entries(values).forEach(([key, value]) => {
          //   if (value === "" || value === undefined || value === null) {
          //     delete values[key];
          //   }
          // });

          values = {
            ...values,
            dienThoai: removeSpaces(values.dienThoai),
            nguonBn: values?.nguonBn ?? null,
            // tenDoan:
            //   values?.nguonBn === "Đoàn khám tại viện" ||
            //   values?.nguonBn === "Đoàn khám tại địa phương"
            //     ? values?.tenDoan
            //     : null,
          };
          try {
            if (action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI) {
              // let response;
              let response = await saveData(
                {
                  ...values,
                  maBenhNhan: null,
                  ...dt.insuranceData,
                  chinhSachApDungs: dt.appliedPolicy,
                  trangThai: 0,
                  trangThaiThanhToan: 0,
                  lanThanhToan: 0,
                  hoanThanhKhaiBao: false,
                  nhanVienTiepNhan: localStorage.getItem("fullName"),
                },
                false,
                0
              );
              // console.log("ressssssssssssssss", response);

              if (response.status && response.status == 200) {
                Notification("success", "Thêm thành công!");
                dispatch(setReload(true));
                dispatch(
                  setPatientRecord({
                    selected: true,
                    record: response.data,
                  })
                );
                dispatch(
                  setAction({
                    actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                    dataPassing: response.data,
                  })
                );
              }
              resolve({ status: true, data: response.data });
              setLoadingBtn(false);
              setLoading(false);
            } else if (
              action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM
            ) {
              const data = {
                ...action.dataPassing,
                ...dt.insuranceData,
                ...values,
                chinhSachApDungs: dt.appliedPolicy,
                thoiGianMienCungChiTra: values.thoiGianMienCungChiTra ?? null,
              };

              let response = await saveData(data, false, 1);

              Notification("success", "Cập nhật phiếu khám thành công!");
              dispatch(setReload(true));
              dispatch(
                setPatientRecord({
                  selected: true,
                  record: response.data,
                })
              );
              dispatch(
                setAction({
                  actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                  dataPassing: response.data,
                })
              );
              // }
              resolve({ status: true, data: response.data });
              setLoadingBtn(false);
              setLoading(false);
            } else if (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
              let response = await saveData(
                {
                  ...values,
                  maBenhNhan: values.maBenhNhan,
                  ...dt.insuranceData,
                  chinhSachApDungs: dt.appliedPolicy,
                  trangThai: 0,
                  trangThaiThanhToan: 0,
                  lanThanhToan: 0,
                  hoanThanhKhaiBao: false,
                  nhanVienTiepNhan: localStorage.getItem("fullName"),
                  id: null,
                },
                false,
                0
              );
              const data = {
                ...response.data,
                maBenhNhan: response?.data?.maBenhNhan,
              };

              if (response.status && response.status == 200) {
                Notification("success", "Thêm phiếu khám mới thành công!");
                dispatch(setReload(true));
                dispatch(
                  setPatientRecord({
                    selected: true,
                    record: data,
                  })
                );
                dispatch(
                  setAction({
                    actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
                    dataPassing: data,
                  })
                );
              }
              resolve({ status: true, data: data });
              setLoadingBtn(false);
              setLoading(false);
            }
          } catch (err) {
            console.log(err);
            if (err.response) {
              Notification("error", err.response.data ?? "Lỗi xảy ra!");
              setLoadingBtn(false);
              setLoading(false);
            } else Notification("error", "Đã xảy ra lỗi!");
            resolve({ status: false, data: null });
            setLoading(false);
            setLoadingBtn(false);
          }
        })
        .catch(() => {
          setLoading(false);
          setLoadingBtn(false);
        });
    });
  };

  const onShowModalSignSecure = async (e) => {
    try {
      await handleOnView();

      signSecureRef.current.openModal();
      // await receiveService.requireSignSecure(action?.dataPassing.id);
    } catch (error) {
      if (error.response) {
        // Xử lý lỗi từ phản hồi API ở đây
        console.log(error.response.status); // Trạng thái lỗi
        console.log(error.response.data); // Thông điệp lỗi
      } else if (error.request) {
        // Xử lý lỗi khi không nhận được phản hồi từ máy chủ
        console.log(error.request);
      } else {
        // Xử lý lỗi khác
        console.log("Error", error.message);
      }
      console.log("🚀 ~ onShowModalSignSecure ~ error:", error);
      Notification("error", "Yêu cầu kí bảo mật không thành công");
    }
  };

  const handleRequireSignSecure = async () => {
    try {
      await receiveService.requireSignSecure(action?.dataPassing.id);
      Notification("success", "Yêu cầu kí bảo mật thành công.");
    } catch (error) {
      console.log("🚀 ~ onShowModalSignSecure ~ error:", error);
      Notification(
        "error",
        error.response.data ?? "Yêu cầu kí bảo mật không thành công"
      );
    }
  };
  const getBNById = async (idBenhNhan) => {
    let response = await medicalExaminationService.getPatientById({
      id: idBenhNhan,
    });
    return response.data;
  };
  const getPKById = async (id) => {
    let response = await medicalExaminationService.getPKById({
      id: id,
    });
    return response.data;
  };

  useEffect(() => {
    if (activeTab == tabKeys.RECEIVE.TAB_2) {
      dispatch(
        setButtonsHeader([
          CompleteKCBBtn(completeKCBFunc, {
            insuranceData: insuranceData,
            appliedPolicy: appliedPolicy,
          }),
          CancelBtn(cancelFunc),
          NewPatientBtn(newPatientFunc),
          NewMedicalBillBtn(newMedicalBillFunc),
          CompleteBtn(completeFunc, loadingBtn),
          PayBtn(payFunc, loadingBtn),

          SavePrintBtn(
            savePrintFunc,
            {
              insuranceData: insuranceData,
              appliedPolicy: appliedPolicy,
            },
            loadingBtn
          ),
          SaveBtn(
            saveFunc,
            {
              insuranceData: insuranceData,
              appliedPolicy: appliedPolicy,
            },
            loadingBtn
          ),
        ])
      );
    }
  }, [activeTab, loadingBtn, action]);
  const resetFormField = () => {
    form.resetFields();
    form.setFieldsValue({
      xa: null,
      huyen: null,
      tinh: null,
      gioiTinh: null,
      gioiTinhThanNhan: null,
      quanHeThanNhan: null,
      loaiKCB: null,
      dichVu: null,
      phong: null,
      doiTuong: null,
      nguonBn: null,
      danToc: 0,
      ngheNghiep: "Nghề khác",
    });
  };

  //lần đàu tiên vào sẽ kiểm tra là loại thực hiện hành động là gì?
  useEffect(() => {
    setLoading(true);
    //kiểm tra xem có phải là thay đổi dữ liệu phiếu khám?
    if (action.actionType == RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
      resetFormField();
      setAppliedPolicy([]);
      // console.log(action.dataPassing);
      receiveSetFieldsValue(form, {
        ...action.dataPassing,
        maBenhNhan: action.dataPassing?.maBenhNhan,
      });
      setAppliedPolicy(action.dataPassing.chinhSachApDungs);
      dispatch(setIdPhieuKham(action.dataPassing.id));
    }
    //kiểm tra xem cso phải là BN mới

    if (action.actionType == RECEIVE_ACTION_TYPE.BENHNHANMOI) {
      resetFormField();
      setAppliedPolicy([]);
      const dataOfNewPatientBNM = {
        id: action?.dataPassing?.id,
        ngayNhapVien: convertDateStringToDateTimezone_7(dayjs()),
        loaiKcb: JSON.parse(localStorage.getItem("loaiKCB"))?.[0]?.value ?? 4,
        phong:
          JSON.parse(localStorage.getItem("phongKhamNoPeople"))?.[0]?.value ??
          0,
        dichVu: JSON.parse(localStorage.getItem("dichVu"))?.[0]?.value ?? 0,
      };
      form.setFieldsValue({ ...action.dataPassing });
      receiveSetFieldsValue(form, dataOfNewPatientBNM);
    }

    //Kiểm tra xem cso phải là phiếu khám mới
    if (action?.actionType == RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
      if (action?.dataPassing && action?.dataPassing?.id) {
        getPKById(action?.dataPassing?.id)
          .then((res) => {
            const values = {
              ...res,
              id: null,
              hoTen: res.hoTen,
              ngaySinh: res.ngaySinh,
              maBenhNhan: res?.maBenhNhan,
              ngayNhapVien: dayjs.tz().toISOString(),
              trangThai: 0,
              tuoi: birthday2Age(res.ngaySinh),
              tinh: res.tinh,
              huyen: res.huyen,
              xa: res.xa,
              diaChi: res.diaChi,
              email: res.email,
              chinhSachApDungs: res.chinhSachApDungs,
              gioiTinh: res.gioiTinh,
              dienThoai: res.dienThoai,
              loaiKcb:
                action?.dataPassing?.loaiKcb === 4 ||
                action?.dataPassing?.loaiKcb === 5
                  ? 1
                  : action?.dataPassing?.loaiKcb ?? 0,
            };
            receiveSetFieldsValue(form, values);
            setAppliedPolicy(values.chinhSachApDungs);
          })
          .catch((err) => {});
      } else {
        if (action?.dataPassing && action.dataPassing?.maBenhNhan) {
          getBNById(action?.dataPassing?.maBenhNhan)
            .then((res) => {
              resetFormField();
              const values = {
                id: null,
                hoTen: res.hoTen,
                ngaySinh: res.ngaySinh,
                maBenhNhan: res?.maBenhNhan,
                ngayNhapVien: dayjs.tz().toISOString(),
                trangThai: 0,
                tuoi: birthday2Age(res.ngaySinh),
                tinh: res.tinh,
                huyen: res.huyen,
                xa: res.xa,
                diaChi: res.diaChi,
                email: res.email,
                chinhSachApDungs: res.chinhSachApDungs,
                gioiTinh: res.gioiTinh,
                loaiKcb:
                  JSON.parse(localStorage.getItem("loaiKCB"))?.[0]?.value ?? 0,
                dienThoai: res.dienThoai,
                duchVu: 0,
                phong:
                  JSON.parse(localStorage.getItem("phongKhamNoPeople"))?.[0]
                    ?.value ?? 0,
                dichVu:
                  JSON.parse(localStorage.getItem("dichVu"))?.[0]?.value ?? 0,
              };
              receiveSetFieldsValue(form, values);
            })
            .catch((err) => {});
        } else {
          if (action?.dataPassing?.maBenhNhan) {
            form.setFieldsValue({
              maBenhNhan: action?.dataPassing?.maBenhNhan,
              id: action.dataPassing?.id,
              trangThai: 0,
            });
          } else if (action?.dataPassing?.id) {
            form.setFieldsValue({
              id: action?.dataPassing?.id,
              trangThai: 0,
            });
          }
        }
      }
    }

    setLoading(false);
  }, [action]);
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row className="receive-container">
        <Space direction="horizontal" align="start" size={24}>
          <Row className="receive-item">
            <Row
              justify={"space-between"}
              style={{
                marginBottom: "12px",
              }}
            >
              <Col>
                <Row>
                  <Button
                    className="btn-sub"
                    onClick={handleRequireSignSecure}
                    // disabled={action.dataPassing?.id ? false : true}
                  >
                    Ký bảo mật thông tin
                  </Button>
                  <Button
                    className="btn-sub"
                    onClick={onShowModalSignSecure}
                    // disabled={action.dataPassing?.id ? false : true}
                  >
                    Xem phiếu BM
                  </Button>
                  <Tooltip
                    title={
                      action.dataPassing?.trangThaiKyBaoMat == 2
                        ? "Bệnh nhân đã ký bảo mật"
                        : "Bệnh nhân chưa ký bảo mật"
                    }
                  >
                    <CheckCircleFilled
                      size={30}
                      className={
                        action.dataPassing?.trangThaiKyBaoMat == 2
                          ? "changeColorGreen"
                          : "noChangeColorGreen"
                      }
                    />
                  </Tooltip>
                </Row>
              </Col>
              <Col>
                <Row justify={"end"}>
                  {!expandMoreInfo ? (
                    <Button
                      icon={<ExpandIconSVG />}
                      className="expand-icon-button"
                      onClick={() => setExpandMoreInfo(!expandMoreInfo)}
                    >
                      Thông tin mở rộng
                    </Button>
                  ) : null}
                  {!expandRelativeInfo ? (
                    <Button
                      icon={<ExpandIconSVG />}
                      className="expand-icon-button"
                      onClick={() => setExpandRelativeInfo(!expandRelativeInfo)}
                    >
                      Nhân thân
                    </Button>
                  ) : null}
                </Row>
              </Col>
            </Row>
            <Space direction="vertical">
              {/* Thông tin chính */}
              <MainInfo {...{ form: form }} />
              {expandMoreInfo ? <Divider type="horizontal" /> : null}
              {/* Mở rộng thoogn tin */}
              <ExpandInfo
                {...{
                  form: form,
                  expandMoreInfo: expandMoreInfo,
                  setExpandMoreInfo: setExpandMoreInfo,
                }}
              />
              {expandRelativeInfo ? <Divider type="horizontal" /> : null}
              <RelativeInfo
                {...{
                  form: form,
                  expandRelativeInfo: expandRelativeInfo,
                  setExpandRelativeInfo: setExpandRelativeInfo,
                }}
              />
              <Divider type="horizontal" />
              <ReceiveInfo {...{ form: form }} />
              <Divider type="horizontal" />
              <RegisterInfo {...{ form: form }} />
            </Space>
          </Row>
          <Row>
            <Space direction="vertical" size={16}>
              <HealthInsuranceInfo {...{ form: form }} />
              <PolicyInfo
                {...{
                  appliedPolicy: appliedPolicy,
                  setAppliedPolicy: setAppliedPolicy,
                }}
              />
              <PatientWaiter />
            </Space>
          </Row>
        </Space>
        <ExanRegBill modalRef={examRef} />
        <CancelModal ref={cancelRef} onCancelOk={handleCancelOk} />
      </Row>
      <ModalCustom ref={modalRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom>
      <ModalCustom
        ref={signSecureRef}
        width={1200}
        title={"Thông tin phiếu bảo mật"}
      >
        <SignedSecure fileImg={fileImg} dataPatient={action.dataPassing} />
      </ModalCustom>
      {/* <SignSecure modalRef={signSecureRef} /> */}
    </Spin>
  );
};

export default Receive;
